// Five outlet menus supplied 2026-10-24. Standalone Pizza items excluded by request.
window.OUTLET_MENU = [
  {
    "name": "Veg Puff (Jain)",
    "handle": "veg-puff-jain",
    "category": "Baked Snacks",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Korean Bun (Jain)",
    "handle": "korean-bun-jain",
    "category": "Baked Snacks",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Paneer Puff (Jain)",
    "handle": "paneer-puff-jain",
    "category": "Baked Snacks",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Blueberry Baked Yoghurt",
    "handle": "bluberry-baked-yoghurt",
    "category": "Baked Yoghurt",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Raspberry Baked Yoghurt",
    "handle": "raspberry-baked-yoghurt",
    "category": "Baked Yoghurt",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Belgium Butterfly Themed Bento Cake",
    "handle": "chocolate-belgium-butterfly-themed-bento-cake",
    "category": "Bento Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Hazelnut Lavender Special Bento Cake",
    "handle": "chocolate-hazelnut-lavender-special-bento-cake",
    "category": "Bento Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Classic Swiss Chocolate Bento Cake",
    "handle": "classic-swiss-chocolate-bento-cake",
    "category": "Bento Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Dutch Truffle Bento Cake",
    "handle": "dutch-truffle-bento-cake",
    "category": "Bento Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chef'S Special Cake (500gm)",
    "handle": "chefs-special-swiss-chocolate-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Raspberry Chocolate Crunch Cake (500gm)",
    "handle": "raspberry-chocolate-crunch-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "The Lavender Cake (500gm)",
    "handle": "the-lavender-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "The Tiramisu Cake (500gm)",
    "handle": "coffee-tiramisu-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Belgian Dark Chocolate Cake (500gm)",
    "handle": "belgian-dark-chocolate-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Black Forest Cake (500gm)",
    "handle": "black-forest-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Hazelnut Cake (500gm)",
    "handle": "chocolate-hazelnut-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Dutch Truffle Cake (500gm)",
    "handle": "dutch-truffle-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Pineapple Cake (500gm)",
    "handle": "pineapple-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Swiss Chocolate Cake (500gm)",
    "handle": "swiss-chocolate-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Sugar-Free Belgian Chocolate Cake (500gm)",
    "handle": "sugar-free-belgian-chocolate-cake",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Dutch Truffle Cake (1kg)",
    "handle": "dutch-truffle-cake-1kg",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Swiss Chocolate Cake (1Kg)",
    "handle": "swiss-chocolate-cake-1kg",
    "category": "Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Hazelnut Cold Coffee",
    "handle": "hazelnut-cold-coffee",
    "category": "Cold Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Classic Cold Coffee",
    "handle": "classic-cold-coffee",
    "category": "Cold Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "1 Belgian Dark Chocolate Pastry + 1 Classic Cold Coffee Combo",
    "handle": "1-belgian-dark-chocolate-pastry-1-classic-cold-coffee-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "1 Chocolate Hazelnut Pastry + 1 Hazelnut Cold Coffee Combo",
    "handle": "1-chocolate-hazelnut-pastry-1-hazelnut-cold-coffee-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "1 Aloo Puff + 1 Classic Cold Coffee Combo",
    "handle": "1-aloo-puff-1-classic-cold-coffee-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "1 Paneer Tikka Sandwich + 1 Dutch Truffle Pastry Combo",
    "handle": "1-paneer-tikka-sandwich-1-dutch-truffle-pastry-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali"
    ]
  },
  {
    "name": "1 Lotus Biscoff Mini Cheesecake & 1 Peanut Butter Chocolate Tub Combo",
    "handle": "1-lotus-biscoff-mini-cheesecake-1-peanut-butter-chocolate-tub-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Swiss Chocolate Cake & 1 Tiramisu Classic Tub Combo",
    "handle": "swiss-chocolate-cake-1-tiramisu-tub-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "3 Brownies & 3 Mini Dessert Tubs Combo",
    "handle": "3-brownies-3-mini-dessert-tubs-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "2 Cake Pops & 2 Cakesicles Combo",
    "handle": "2-cake-pops-2-cakesicles-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Chip Cookies",
    "handle": "chocolate-chip-cookies",
    "category": "Cookies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Jeera Cookies",
    "handle": "jeera-cookies",
    "category": "Cookies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Peanut Butter Cookies",
    "handle": "peanut-butter-cookies",
    "category": "Cookies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Banana Salted Caramel Tub",
    "handle": "banana-salted-caramel",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Raspberry Chocolate Mousse Tub",
    "handle": "raspberry-chocolate-mousse",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Outrageous Brownie",
    "handle": "outrageous-brownie",
    "category": "Brownies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Triple Chocolate Brownie",
    "handle": "triple-chocolate-brownie",
    "category": "Brownies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Mousse Tub",
    "handle": "chocolate-mousse-tub",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Hazelnut Brownie",
    "handle": "hazelnut-brownie",
    "category": "Brownies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Belgian Chocolate Bomboloni",
    "handle": "belgian-chocolate-bomboloni",
    "category": "Desserts",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Nutella Mousse Tub",
    "handle": "nutella-dream-mousse",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Nutella Mini Bomboloni",
    "handle": "nutella-mini-bomboloni",
    "category": "Desserts",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Peanut Butter Chocolate Tub",
    "handle": "peanut-butter-chocolate",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Cake Pop",
    "handle": "cake-pop",
    "category": "Desserts",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Cakesicles",
    "handle": "cakesicles",
    "category": "Desserts",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Donut",
    "handle": "chocolate-donut",
    "category": "Donuts",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Vanilla Cookies",
    "handle": "vanilla-cookies",
    "category": "Cookies",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Cappuccino",
    "handle": "cappuccino",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Espresso",
    "handle": "espresso",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Spanish Hot Latte",
    "handle": "spanish-hot-latte",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Latte",
    "handle": "latte",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Flat White",
    "handle": "flat-white",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Americano",
    "handle": "americano",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Black Tea",
    "handle": "black-tea",
    "category": "Hot Beverages",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Green Tea",
    "handle": "green-tea",
    "category": "Hot Beverages",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Masala Tea",
    "handle": "masala-tea",
    "category": "Hot Beverages",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Lemon Iced Tea",
    "handle": "lemon-iced-tea",
    "category": "Iced Tea | Coolers",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Peach Iced Tea",
    "handle": "peach-iced-tea",
    "category": "Iced Tea | Coolers",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "The Lavender Cooler",
    "handle": "the-lavender-cooler",
    "category": "Iced Tea | Coolers",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Virgin Mojito",
    "handle": "virgin-mojito",
    "category": "Iced Tea | Coolers",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Golden Number Candle 0",
    "handle": "golden-number-candle-0",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 1",
    "handle": "golden-number-candle-1",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 2",
    "handle": "golden-number-candle-2",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 3",
    "handle": "golden-number-candle-3",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 4",
    "handle": "golden-number-candle-4",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 5",
    "handle": "golden-number-candle-5",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 6",
    "handle": "golden-number-candle-6",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 7",
    "handle": "golden-number-candle-7",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 8",
    "handle": "golden-number-candle-8",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Number Candle 9",
    "handle": "golden-number-candle-9",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Sparkle Candle Big",
    "handle": "sparkle-candle-big",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Sparkle Candle Small",
    "handle": "sparkle-candle-small",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Spiral Candle",
    "handle": "spiral-candle",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Anniversary Topper",
    "handle": "happy-anniversary-topper",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Birthday Topper",
    "handle": "happy-birthday-topper",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Silver Crown Girl",
    "handle": "silver-crown-girl",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Party Popper Big",
    "handle": "party-popper-big",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Party Popper Small",
    "handle": "party-popper-small",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Snow Spray",
    "handle": "snow-spray",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "King Crown",
    "handle": "king-crown",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Happy Birthday Sash",
    "handle": "birthday-sash",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Gonda Cap",
    "handle": "gonda-cap",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Normal Cap",
    "handle": "normal-cap",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Lotus Biscoff Mini Cheesecake (150gm)",
    "handle": "lotus-biscoff-mini-cheesecake",
    "category": "Mini Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Tiramisu Mini Cheesecake (150gm)",
    "handle": "tiramisu-mini-cheesecake",
    "category": "Mini Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Red Velvet Mini Cheesecake (150gm)",
    "handle": "red-velvet-mini-cheesecake",
    "category": "Mini Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Black Forest Mini Cake",
    "handle": "black-forest-mini-cake",
    "category": "Mini Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Blueberry Mini Cheesecake (150gm)",
    "handle": "blueberry-mini-cheesecake",
    "category": "Mini Cakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Tiramisu Tres Leches",
    "handle": "tiramisu-tres-leches",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Lavender Tres Leches",
    "handle": "lavender-tres-leches",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Classic Tiramisu Tub",
    "handle": "tiramisu-tub",
    "category": "Dessert Tubs",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Sugar - Free Belgian Chocolate Pastry",
    "handle": "sugar-free-belgian-chocolate-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Sugar - Free Coffee Chocolate Pastry",
    "handle": "sugar-free-coffee-chocolate-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Belgian Dark Chocolate Pastry",
    "handle": "belgian-dark-chocolate-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Blueberry Cheesecake Pastry",
    "handle": "blueberry-cheesecake-pastry",
    "category": "Cheesecakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Hazelnut Pastry",
    "handle": "chocolate-hazelnut-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Dutch Truffle Pastry",
    "handle": "dutch-truffle-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Pineapple Pastry",
    "handle": "pineapple-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Raspberry Chocolate Crunch Pastry",
    "handle": "raspberry-chocolate-crunch-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "The Lavender Pastry",
    "handle": "the-lavender-pastry",
    "category": "Pastries",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Corn Chaat Sandwich",
    "handle": "corn-chaat-sandwich",
    "category": "Sandwiches",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Paneer Tikka Sandwich",
    "handle": "paneer-tikka-sandwich",
    "category": "Sandwiches",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Pav Bhaji Sandwich",
    "handle": "pav-bhaji-sandwich",
    "category": "Sandwiches",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "The Lavender Mlikshake",
    "handle": "the-lavender-mlikshake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Belgian Chocolate Milkshake",
    "handle": "belgian-chocolate-milkshake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Oreo Milkshake",
    "handle": "oreo-milkshake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Nutella Hazelnut Milkshake",
    "handle": "nutella-hazelnut-milkshake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Vanilla Milkshake",
    "handle": "vanilla-milkshake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Lotus Biscoff Cheesecake Pastry",
    "handle": "lotus-biscoff-cheesecake-pastry",
    "category": "Cheesecakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Lavender Donut",
    "handle": "lavender-donut",
    "category": "Donuts",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "1 Lavender Pastry & 1 Belgian Pastry + 1 Lavender Shake & 1 Classic Cold Coffee Combo",
    "handle": "1-lavender-pastry-1-belgian-pastry-1-lavender-shake-1-classic-cold-coffee-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Congratulations Topper",
    "handle": "congratulations-topper",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "1 Veg Puff (jain) + 1 Classic Cold Coffee Combo",
    "handle": "1-veg-puff-jain-1-classic-cold-coffee-combo",
    "category": "Combos",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Golden Queen Crown",
    "handle": "golden-queen-crown",
    "category": "Merchandise",
    "outlets": [
      "ghatkopar"
    ]
  },
  {
    "name": "Lotus Biscoff Shake",
    "handle": "lotus-biscoff-shake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Belgian Hot Chocolate",
    "handle": "belgian-hot-chocolate",
    "category": "Hot Beverages",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Triple Chocolate Brownie Milkshake",
    "handle": "triple-chocolate-brownie-milkshake",
    "category": "Shakes",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Alfredo Pasta",
    "handle": "alfredo-pasta-1",
    "category": "Pasta",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Avocado Toast ( 2 Slices)",
    "handle": "avocado-toast-2-slices",
    "category": "Healthy Food",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Pink Sauce Pasta",
    "handle": "pink-sauce-pasta-1",
    "category": "Pasta",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Pesto Pasta",
    "handle": "pesto-pasta",
    "category": "Pasta",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Quinoa Bowl",
    "handle": "quinoa-bowl",
    "category": "Healthy Food",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Quinoa Bowl + Triple Chocolate Brownie Milkshake",
    "handle": "quinoa-bowl-triple-chocolate-brownie-milkshake",
    "category": "Combos",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Iced Latte",
    "handle": "iced-latte",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Iced Americano",
    "handle": "iced-americano",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Iced Cappuccino",
    "handle": "iced-cappuccino",
    "category": "Hot / Iced Coffee",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chocolate Box Hamper",
    "handle": "chocolate-box-hamper",
    "category": "Diwali Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Brownie & Chocolate Diwali Hamper",
    "handle": "brownie-chocolate-diwali-hamper",
    "category": "Diwali Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Diwali Brownie Hamper",
    "handle": "diwali-brownie-hamper",
    "category": "Diwali Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Diwali Celebration Dessert Hamper",
    "handle": "diwali-celebration-dessert-hamper",
    "category": "Diwali Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Diwali Assorted Brownies & Chocolates Hamper",
    "handle": "diwali-assorted-brownies-chocolates-hamper",
    "category": "Diwali Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Luxury Diwali Dessert Hamper",
    "handle": "luxury-diwali-dessert-hamper",
    "category": "Diwali Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Haunted Banana Caramel Tub",
    "handle": "haunted-banana-caramel-tub",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Ghostly Classic Tiramisu Tub",
    "handle": "ghostly-classic-tiramisu-tub",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Spooky Tiramisu Tres Leches",
    "handle": "spooky-tiramisu-tres-leches",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Halloween Nutella Mousse Tub",
    "handle": "halloween-nutella-mousse-tub",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Halloween Special Dutch Truffle Cake",
    "handle": "halloween-special-dutch-truffle-cake",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Lavender Haunted Halloween Cake",
    "handle": "lavender-haunted-halloween-cake",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Spooky Swiss Chocolate Cake",
    "handle": "spooky-swiss-chocolate-cake",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Dark Magic Belgian Chocolate Cake",
    "handle": "dark-magic-belgian-chocolate-cake",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Pumpkin Halloween Swiss Chocolate Cake",
    "handle": "pumpkin-halloween-swiss-chocolate-cake",
    "category": "Halloween Special",
    "outlets": [
      "ghatkopar",
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Aloo Puff",
    "handle": "aloo-puff",
    "category": "Baked Snacks",
    "outlets": [
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Chinese Puff",
    "handle": "chinese-puff",
    "category": "Baked Snacks",
    "outlets": [
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Korean Bun",
    "handle": "korean-bun",
    "category": "Baked Snacks",
    "outlets": [
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Paneer Puff",
    "handle": "paneer-puff",
    "category": "Baked Snacks",
    "outlets": [
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Cheese Fries",
    "handle": "cheese-fries",
    "category": "French Fries",
    "outlets": [
      "versova",
      "kandivali"
    ]
  },
  {
    "name": "Peri Peri Fries",
    "handle": "peri-peri-fries",
    "category": "French Fries",
    "outlets": [
      "versova",
      "kandivali"
    ]
  },
  {
    "name": "Salted Fries",
    "handle": "salted-fries",
    "category": "French Fries",
    "outlets": [
      "versova",
      "kandivali"
    ]
  },
  {
    "name": "3 Cheese Nachos",
    "handle": "three-cheese-nachos",
    "category": "Nachos",
    "outlets": [
      "versova",
      "kandivali"
    ]
  },
  {
    "name": "Nachos Classic",
    "handle": "nachos-classic",
    "category": "Nachos",
    "outlets": [
      "versova",
      "kandivali"
    ]
  },
  {
    "name": "Mushroom And Cheese Sandwich",
    "handle": "mushroom-and-cheese-sandwich",
    "category": "Sandwiches",
    "outlets": [
      "versova",
      "kandivali",
      "borivali",
      "vile-parle"
    ]
  },
  {
    "name": "Paneer Hot Dog",
    "handle": "veg-paneer-hot-dog",
    "category": "Baked Snacks",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Paneer Masala Roll",
    "handle": "paneer-masala-roll",
    "category": "Baked Snacks",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Veg Hot Dog",
    "handle": "veg-hot-dog",
    "category": "Baked Snacks",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Chilli Paneer Dry",
    "handle": "chilli-paneer-dry",
    "category": "Chinese Starter",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Nescafe Milk Coffee",
    "handle": "nescafe-milk-coffee",
    "category": "Hot Beverages",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Black Coffee",
    "handle": "black-coffee",
    "category": "Hot Beverages",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Burnt Garlic Noodles",
    "handle": "burnt-garlic-noodles",
    "category": "Rice | Noodles",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Burnt Garlic Rice",
    "handle": "burnt-garlic-rice",
    "category": "Rice | Noodles",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Hakka Noodles",
    "handle": "hakka-noodles",
    "category": "Rice | Noodles",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Schezwan Fried Noodles",
    "handle": "schezwan-fried-noodles",
    "category": "Rice | Noodles",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Schezwan Fried Rice",
    "handle": "schezwan-fried-rice",
    "category": "Rice | Noodles",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Lotus Biscoff Cheesecake (600gm)",
    "handle": "lotus-biscoff-cheesecake",
    "category": "Cheesecakes",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Red Velvet Cake (500gm)",
    "handle": "red-velvet-cheesecake",
    "category": "Cakes",
    "outlets": [
      "kandivali"
    ]
  },
  {
    "name": "Choco Lava",
    "handle": "choco-lava",
    "category": "Desserts",
    "outlets": [
      "kandivali"
    ]
  }
].filter(function (item) {
  return item.category !== 'Halloween Special';
});
